export function Toggle({
  checked,
  onChange,
  title,
  sub,
  disabled = false,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  title: string;
  sub?: string;
  disabled?: boolean;
}) {
  return (
    <label className="toggle" style={disabled ? { opacity: 0.55, cursor: 'default' } : undefined}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-track" aria-hidden />
      <span className="toggle-text">
        <span className="toggle-title">{title}</span>
        {sub && <span className="toggle-sub">{sub}</span>}
      </span>
    </label>
  );
}
